"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapStatus = void 0;
var CapStatus;
(function (CapStatus) {
    CapStatus["Active"] = "Active";
    CapStatus["Ended"] = "Ended";
    CapStatus["Upcoming"] = "Upcoming";
})(CapStatus || (exports.CapStatus = CapStatus = {}));
